import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import Updates from "./components/Updates";
import BooklistsSection from "./components/BooklistsSection";
import TagsSection from "./components/TagsSection";
import Faq from "./components/Faq";
import Cta from "./components/Cta";
import { comics, faqs } from "../../mocks/manga";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "妖精漫画网",
      url: "https://readdiary.github.io/",
      logo: "https://readdiary.github.io/vite.svg",
      description: "妖精漫画网提供漫画阅读、收藏、下载、书单与标签整理功能。",
    },
    {
      "@type": "WebSite",
      name: "妖精漫画网",
      url: "https://readdiary.github.io/",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://readdiary.github.io/library?keyword={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
    {
      "@type": "ItemList",
      name: "妖精漫画网热门追更",
      itemListElement: comics.slice(0, 8).map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.title,
        url: `https://readdiary.github.io/detail/${c.id}`,
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Categories />
        <Updates />
        <BooklistsSection />
        <TagsSection />
        <Faq />
        <Cta />
      </main>
      <Footer />
    </>
  );
}